
export default {
  data: () => ({
    error: false
  }),
  errorCaptured (err, vm, info) {
    this.error = true
  },
  render () {
    return this.error ? null : this.$slots.default[0]
  }
}
